import angular from 'angular';
import 'angular-ui-router';
import 'satellizer';
import Configs from '../../../configs/configs';
import Services from '../../../services/services';
import Resources from '../../../resources/resources';
import template from './login.jade';
import {isAllNumbers} from "../../../common/util/validation-util";
import QrCode from '../qrcode/qrcode';

export class LoginController {
  /* @ngInject */
  constructor(MeResource, currentUser, GameDevelopersResource, api, $http, $state, $filter, $auth, notify, $analytics, $window, initialUrl){
    this.$state = $state;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.notify = notify;
    this.$auth = $auth;
    this.$http = $http;
    this.api = api;
    this.$analytics = $analytics;
    this.$window = $window;
    this.MeResource = MeResource;
    this.currentUser = currentUser;
    this.GameDevelopersResource = GameDevelopersResource;
    this.initialUrl = initialUrl.get();
    this.isMfaVisible = false;
    this.isQrVisible = false;
    this.isMfaConfigured = false;
    this.qrCodeLink = null;
    this.qrError = false;
    this.mfaAccessToken = null;

    this.showMfaField = {
      className: 'layout__item u-1/1',
      type: 'input',
      key: 'mfa_code',
      templateOptions: {
        label: this.translate('mfa_code'),
        type: 'text',
        required: true
      },
      validators: {
        isAllNumbers: {
          expression: ($viewValue, $modelValue, scope) => { return isAllNumbers($modelValue) }
        }
      }
    }

    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'email',
        templateOptions: {
          label: this.translate('email'),
          type: 'email',
          required: true,
          focus: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'password',
        templateOptions: {
          label: this.translate('password'),
          type: 'password',
          required: true
        }
      }
    ];
  }

  shouldShowAffleIcon() {
    return this.$window.location.href && this.$window.location.href.includes("mdsp.affle.com");
  }

  handleSuccessfulLogin() {
    this.MeResource.one().get().then((user) => {
      let fullName = `${user.first_name} ${user.last_name}`;
      this.currentUser.onNext(user);
      this.getGameDeveloper(user)
        .then(() => {
          this.trackUserLogin();

          this.notify.success('loggedIn', {
            name: _.get(this.gameDeveloper, 'company_name', fullName)
          });

          if (user.hasRole(['DEMO'])) {
            this.$state.go('app.games.index');
          } else if (user.hasRole(['ADMIN'])) {
            this.$state.go('app.games.revenue');
          } else if (user.hasRole(['GG_ACCOUNT_MANAGER'])) {
            this.$state.go('app.admin.gameDevelopers.index');
          } else {
            this.$state.go('app.games.index');
          }
        });
    })
  }

  addMfaField() {
    this.isMfaVisible = true;
    let insertAt = _.findIndex(this.fields, {key: 'password'}) + 1;
    Array.prototype.splice.apply(this.fields, [insertAt, 0].concat([this.showMfaField]));
  }

  login() {
    if (!this.isMfaVisible) {
      this.$auth.login({
        username: this.user.email,
        password: this.user.password,
        grant_type: 'password',
        client_id: 'ba641f1e-87ba-4117-877c-761450b418e1'
      }, {
        headers: {'Requested-From-Component': 'pepapi-frontend'}
      })
      .then((response) => {
        if (response.data.token_type !== 'mfa') {
          this.handleSuccessfulLogin();
        } else {
          this.mfaAccessToken = response.data.access_token;
          this.isMfaConfigured = response.data.mfa_configured;
          this.$auth.removeToken();
          this.addMfaField();
          if (!this.isMfaConfigured) {
            this.showQrCode();
          }
        }
      })
      .catch((response) => {
        if (response.status === 401) {
          if (!!response.data && !!response.data.error && response.data.error === "user blocked") {
            this.notify.error('logInBlocked')
          } else {
            this.notify.error('logInFailed')
          }
        } else if (response.status === 403) {
          this.notify.error('logInForbidden')
        } else {
          this.notify.apiError(response);
        }
      })
    } else {
        if (this.isMfaConfigured) {
            this.verifyMfa();
        } else {
            this.configureMfa();
        }
    }
  }

  configureMfa() {
    this.$http.post(`${this.api.baseURL}/oauth/v2/token/mfa/configure`, {
      code: this.user.mfa_code
    }, {
      headers: {
        'Requested-From-Component': 'pepapi-frontend',
        'Authorization': `Bearer ${this.mfaAccessToken}`,
      },
    }).then(() => {
      this.isMfaConfigured = true;
      this.isQrVisible = false;
      this.verifyMfa();
    }).catch((err) => {
      console.error('Error configuring MFA', err);
      this.notify.error('mfaConfigureFailed');
    });
  }

  verifyMfa() {
    this.$http.post(`${this.api.baseURL}/oauth/v2/token/mfa/verify`, {
      code: this.user.mfa_code
    }, {
      headers: {
        'Requested-From-Component': 'pepapi-frontend',
        'Authorization': `Bearer ${this.mfaAccessToken}`,
      },
    })
    .then((result) => {
      this.$auth.setToken(result.data.access_token);
      this.handleSuccessfulLogin();
    })
    .catch((err) => {
      console.error('Error verifying MFA', err);
      this.notify.error('logInMfaFailed')
    })
  }

  showQrCode() {
    this.qrError = false;
    this.$http.get(`${this.api.baseURL}/oauth/v2/token/mfa/enable`, {
      headers: {
        'Requested-From-Component': 'pepapi-frontend',
        'Authorization': `Bearer ${this.mfaAccessToken}`,
      }
    }).then((res) => {
      this.qrCodeLink = res.data.mfa_link;
      this.isQrVisible = true;
    }).catch((err) => {
      console.error('Error enabling MFA', err);
      this.qrError = true;
      this.isQrVisible = true;
    });
  }

  getGameDeveloper(user) {
    if (!_.isEmpty(user.game_developer_ids)) {
      return this.GameDevelopersResource.one(user.game_developer_ids[0]).get()
        .then(gameDeveloper => this.gameDeveloper = gameDeveloper)
        .catch(this.notify.apiError)
    } else {
      return {then: (cb) => cb()}
    }
  }

  trackUserLogin(){
    this.$analytics.setUsername(this.user.email);
    if (this.gameDeveloper) {
      this.$analytics.eventTrack('SignIn', {category: 'General', label: this.gameDeveloper.company_name});
    } else {
      this.$analytics.eventTrack('SignIn', {category: 'General', label: 'Unknow'});
    }
  }
}

export function LoginComponent() {
  return {
    template,
    controller: LoginController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
}

export default angular.module('login', [
  Configs.name,
  Resources.name,
  Services.name,
  'ui.router',
  'satellizer',
  'qrCode'
])
  .service('initialUrl', ($window) => {
    return {
      _initialUrl: $window.location.href,
      get() {
        const initialUrl = this._initialUrl;
        this._initialUrl = null;
        return initialUrl;
      }
    };
  })
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('login', {
        url: '/login',
        template: '<login></login>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.login');
          }
        },
        data: {
          permissions: {
            only: ['anonymous'],
            redirectTo: ''
          }
        }
      });
  })
  .directive('login', LoginComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/login/login.js
 **/